import { render } from "./diff_view.vue?vue&type=template&id=d973a1ea&scoped=true"
import script from "./diff_view.vue?vue&type=script&lang=js"
export * from "./diff_view.vue?vue&type=script&lang=js"

import "./diff_view.vue?vue&type=style&index=0&id=d973a1ea&lang=scss&scoped=true"

import exportComponent from "../../../../../../node/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d973a1ea"]])

export default __exports__